import { useQuery } from '@tanstack/react-query'
import { ITreatmentSchemaOptions } from 'models/ICattlesData'
import CattlesApiService from 'services/cattlesApiServices'

export const useGetTreatmentSchemasOptions = () => {
	const { data, isLoading, error, refetch } = useQuery<
		ITreatmentSchemaOptions[]
	>({
		queryKey: ['treatmentSchemasOptions'],
		queryFn: async () => {
			const response = await CattlesApiService.getTreatmentSchemaOptions()
			if (!response.length) return []

			const maxId = Math.max(...response.map(item => item.id))
			const maxIdItem = response.find(item => item.id === maxId)
			const mainGroup = maxIdItem ? maxIdItem.group : null

			const sorted = response.slice().sort((a, b) => {
				if (a.group === mainGroup && b.group !== mainGroup) return -1
				if (b.group === mainGroup && a.group !== mainGroup) return 1

				if (a.group < b.group) return -1
				if (a.group > b.group) return 1

				return b.id - a.id
			})

			return sorted
		},
	})

	return { data, isLoading, error, refetch }
}
